module.exports = __webpack_public_path__ + "static/media/lease-truck-program-hero.5541caa2.jpg";